module.exports = __webpack_public_path__ + "static/media/cancelTil.4ad01869.svg";